import React from "react";
import PropTypes from "prop-types";
import { Typography, Button } from "@mui/material";
import EnhancedCard from "common/components/EnhancedCard";
import DataProvider from "common/components/DataProvider";
import Resource from "common/components/Resource";
import OfferList from "core/OfferList";
import { useTranslation } from "react-i18next";

const ResourceOffers = ({ resource, history }) => {
  const { t } = useTranslation();
  return (
    <EnhancedCard
      title={t("offers_list.title")}
      cardContentRoot={{ padding: 0 }}
      cardHeaderStyle={{ fontSize: "1.25rem" }}
      action={
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            history.push(`/${resource.singular}/${resource.id}/offers/new`);
          }}
        >
          {t("offers_list.create_btn")}
        </Button>
      }
    >
      <Resource
        name="offer_templates"
        render={(offerTemplates) => (
          <DataProvider
            url={`/${resource.plural}/${resource.id}/offers`}
            error={() => (
              <Typography>{t("offers_list.no_offer_found")}</Typography>
            )}
            render={(data) => <OfferList offers={data} resource={resource} />}
          />
        )}
      />
    </EnhancedCard>
  );
};

ResourceOffers.propTypes = {
  resource: PropTypes.shape({
    id: PropTypes.number.isRequired,
    singular: PropTypes.string.isRequired,
    plural: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default ResourceOffers;
